/**
 * Currency formatting utility for Ghanaian Cedi (GHS)
 */

/**
 * Format a number as Ghanaian Cedi currency
 * @param {number} amount - The amount to format
 * @param {object} options - Formatting options
 * @param {boolean} options.showDecimals - Whether to show decimal places (default: true)
 * @param {number} options.decimalPlaces - Number of decimal places (default: 2)
 * @returns {string} Formatted currency string
 */
export function formatCurrency(amount, options = {}) {
  const { showDecimals = true, decimalPlaces = 2 } = options;
  
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 'Ghs 0.00';
  }

  const numAmount = parseFloat(amount);
  
  if (showDecimals) {
    const formatted = numAmount.toFixed(decimalPlaces);
    const parts = formatted.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `Ghs ${integerPart}.${parts[1]}`;
  } else {
    return `Ghs ${Math.round(numAmount).toLocaleString()}`;
  }
}

/**
 * Format a large amount with abbreviations (K, M, etc.)
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string with abbreviation
 */
export function formatCurrencyShort(amount) {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 'Ghs 0';
  }

  const numAmount = parseFloat(amount);
  
  if (numAmount >= 1000000) {
    return `Ghs ${(numAmount / 1000000).toFixed(1)}M`;
  } else if (numAmount >= 1000) {
    return `Ghs ${(numAmount / 1000).toFixed(1)}K`;
  } else {
    return formatCurrency(numAmount);
  }
}

export default formatCurrency;

